export default "__VITE_ASSET__2xubYGGG__"